export const FLEX_CENTER_CENTER = `
    display: flex;
    justify-content: center;
    align-items: center;
  `;

export const FLEX_GLOW = `
  flex: 1;
`;

export const ELLIPSIS = `
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
`;
